/* Course page behavior — scroll reveals, accordions, testimonial slider. Ticket 09. */
(function () {
  'use strict';

  // Several sections include this file; run once.
  if (window.__crsInit) return;
  window.__crsInit = true;

  function init() {
    // Scroll reveal (fade-up)
    var revealables = document.querySelectorAll('[data-crs-reveal]');
    if ('IntersectionObserver' in window && revealables.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('crs-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
      );
      revealables.forEach(function (el) { io.observe(el); });
    } else {
      revealables.forEach(function (el) { el.classList.add('crs-in'); });
    }

    // Accordions
    document.querySelectorAll('[data-crs-accordion]').forEach(function (item) {
      var header = item.querySelector('.crs-accordion-header');
      var content = item.querySelector('.crs-accordion-content');
      if (!header || !content) return;
      header.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        header.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Testimonial sliders
    document.querySelectorAll('[data-crs-testimonials]').forEach(function (slider) {
      var slides = JSON.parse(slider.querySelector('[data-crs-slides]').textContent);
      if (!slides.length) return;
      var quoteEl = slider.querySelector('[data-crs-quote]');
      var authorEl = slider.querySelector('[data-crs-author]');
      var courseEl = slider.querySelector('[data-crs-course]');
      var courseLabelEl = slider.querySelector('[data-crs-course-label]');
      var photos = Array.prototype.slice.call(slider.querySelectorAll('.crs-photo-stack img'));
      var index = 0;

      function render() {
        var slide = slides[index];
        quoteEl.textContent = slide.quote;
        authorEl.textContent = slide.author;
        // Optional per-slide course link (used by the homepage slider; course
        // pages omit the element entirely).
        if (courseEl) {
          if (slide.courseLabel && slide.courseUrl) {
            courseEl.href = slide.courseUrl;
            if (courseLabelEl) courseLabelEl.textContent = slide.courseLabel;
            courseEl.style.display = '';
          } else {
            courseEl.style.display = 'none';
          }
        }
        photos.forEach(function (img) {
          var i = parseInt(img.getAttribute('data-slide-index'), 10);
          img.classList.remove('is-active', 'is-behind-1', 'is-behind-2', 'is-hidden');
          if (!photos.length) return;
          if (i === index) img.classList.add('is-active');
          else if (i === (index + 1) % slides.length) img.classList.add('is-behind-1');
          else if (i === (index + 2) % slides.length) img.classList.add('is-behind-2');
          else img.classList.add('is-hidden');
        });
      }

      slider.querySelectorAll('[data-crs-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          index = (index - 1 + slides.length) % slides.length;
          render();
        });
      });
      slider.querySelectorAll('[data-crs-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          index = (index + 1) % slides.length;
          render();
        });
      });
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
